import { useState, useEffect } from 'react';
import { userStoreState, useStoreState } from 'easy-peasy';
import { Link as RouterLink, useNavigate, matchPath, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { GetAthourized } from '../services/http';
import './header.css';
import { AnimateFront } from '../services/animation';
import LoginButtonDialog from '../dialogs/login-dialog';

export const Navbar = () => {
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const config = useStoreState((state) => state.config);
  const getUserCryptoList = async () => {
    const userServerData = await GetAthourized('/api/auth/GetUserCryptoList', '');
    if (userServerData.result) {
      setUserData(userServerData);
      setIsAdmin(userServerData.isAdmin);
    } else {
      setUserData(null);
    }
  };
  const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  };
  const setPartner = () => {
    const isPartner = window.location.href.includes('eff=');
    if (isPartner) {
      const partnerSlug = window.location.href.split('eff=')[1].split('&')[0];
      setCookie('partnerSlug', partnerSlug, 386);
    }
  };
  const logOut = () => {
    localStorage.removeItem('token');
    window.location.reload();
  };
  const menuItems = [
    {
      href: '/',
      label: 'Main'
    },

    {
      href: '/about-us',
      label: 'About Us'
    },
    /*   {
        href: '/campaigns',
        label: 'Campaigns'
      }, */
    {
      href: '/why-us',
      label: 'Why us?',
      /*  children: [{
         href: '/why-us-he',
         label: '?למה אנחנו'
       }] */
    },
    {
      href: '/why-us-he',
      label: '?למה אנחנו'
    },
    {
      href: '/our-champions',
      label: 'Our Champions'
    },
    {
      href: '/sign-up-campaign',
      label: 'Create Account'
    },
    {
      href: '/contact-us',
      label: 'Contact Us'
    },
  ];
  useEffect(() => {
    AnimateFront();
    setPartner();
  }, []);

  return (
    <>
      <header className="header  _fadeDown _anim-items _anim-no-hide">
        <div className="container-fluid header__container" style={{ justifyContent: 'center'}} >
          <div className="header__left">

            <a href="#" className="header__logo logo">
              <img src="/img/new-logo.png" alt="" />
              <img class="gif" src="/img/gif/Logo.gif" alt="" />
            </a>

            {/* <img class="mobile-logo visible-ipad" src="/img/mobile-logo.png" alt="" />
             <div className="header__lang lang ">
              <div className="lang__button">ENG</div>
              <div className="lang__drop">
                <div className="lang__drop-item">FRA</div>
                <div className="lang__drop-item">RUS</div>
              </div>
            </div> */}

            {/* <div className="header__search-block search-block">
              <form action="#">
                <input type="text" placeholder="Search campaigns" className="search-block__input" />
                <span className="search-block__icon">
                  <img src="/img/sprite/zoom.svg" alt="" />
                </span>
              </form>
            </div> */}
          </div>

          <div className="header__bottom" style={{ position: 'relative' }}>
            <div className="desktop">
              <ul className="main-menu" style={{ background: 'white' }}>
                {menuItems.map((item) => (
                  <li className="main-menu__item">
                    <a
                      style={{ color: '#1979be', textDecoration: 'none', fontSize: '16px' }}
                      href={item.href}
                      className={matchPath({ path: item.href, end: true }, location.pathname) ? 'main-menu__link _active' : 'main-menu__link'}
                    >
                      {item.label}
                    </a>
                    {item.children != null ? (
                      <div class="main-sub-menu">
                        {item.children.map((child) => (
                          <a href={child.href} className="font-small" style={{ color: '#1979be', textDecoration: 'none' }}>{child.label}</a>
                        ))}
                      </div>
                    ) : ''}
                  </li>
                ))}
              </ul>
              <a onClick={() => { setMobileMenuOpen(true); }} className="header__burger burger" data-nav-swipe-open="1">
                <div className="burger__icon" />
              </a>
            </div>
          </div>
          <LoginButtonDialog />
          {/* <a className="header__user-block user-block" rel="noreferrer" target="_blank" href={config.dashboardDomain}>
            <div className="user-block__img">
              <img src="/img/user.png" alt="" />
            </div>
          </a> */}
          <div style={{ marginLeft: '30px' }}>
            <a onClick={() => { setMobileMenuOpen(true); }} className="burger" data-nav-swipe-open="1">
              <MenuIcon style={{ fontSize: '20px' }} />
            </a>
          </div>

        </div>
        <div className="header__bottom" style={{ display: 'none' }}>
          <div className="container desktop">
            <ul className="main-menu">
              {menuItems.map((item) => (
                <li className="main-menu__item">
                  <a
                    href={item.href}
                    className={matchPath({ path: item.href, end: true }, location.pathname) ? 'main-menu__link _active' : 'main-menu__link'}
                  >
                    {item.label}
                  </a>
                  {item.children != null ? (
                    <div class="main-sub-menu">
                      {item.children.map((child) => (
                        <a href={child.href}>{child.label}</a>
                      ))}
                    </div>
                  ) : ''}
                </li>
              ))}
            </ul>
            <a onClick={() => { setMobileMenuOpen(true); }} className="burger" data-nav-swipe-open="1">
              <div className="burger__icon" />
            </a>
          </div>
        </div>
      </header>
      <nav className={mobileMenuOpen ? 'navbar _open' : 'navbar'}>
        <div className="navbar__container">
          <div className="navbar__close" onClick={() => { setMobileMenuOpen(false); }}></div>
          <ul className="navbar-menu">
            {menuItems.map((item) => (
              <li className="main-menu__item">
                <a
                  href={item.href}
                  className={matchPath({ path: item.href, end: true }, location.pathname) ? 'main-menu__link _active' : 'main-menu__link'}
                >
                  {item.label}
                </a>
                {item.children != null ? (
                  <div class="main-sub-menu">
                    {item.children.map((child) => (
                      <a href={child.href}>{child.label}</a>
                    ))}
                  </div>
                ) : ''}
              </li>
            ))}
          </ul>
        </div>
        <div className="navbar__overlay"></div>
      </nav>
    </>
  );
};
